import axiosInstance from "./axiosInstance";

/**
 * Fetches a paginated list of whitelisted IPs.
 * @returns {Promise} The promise from the axios GET request.
 */
export const getIpWhitelist = () => {
  return axiosInstance.get("/ip_whitelist", {
    params: { site: process.env.REACT_APP_SITE_ID },
  });
};

/**
 * Creates a new whitelisted IP.
 * @param {object} ipData - The data for the new IP.
 * @param {string} ipData.ip - The IP address.
 * @param {string} ipData.note - A note about the IP.
 * @param {string} ipData.createdBy - The user creating the IP.
 * @returns {Promise} The promise from the axios POST request.
 */
export const createIpWhitelist = (ipData) => {
  const payload = { ...ipData, site: process.env.REACT_APP_SITE_ID };
  return axiosInstance.post("/ip_whitelist", payload);
};

/**
 * Updates a whitelisted IP.
 * @param {string} id - The ID of the IP to update.
 * @param {object} ipData - The updated data.
 * @returns {Promise} The promise from the axios PATCH request.
 */
export const updateIpWhitelist = (id, ipData) => {
  const payload = { ...ipData, site: process.env.REACT_APP_SITE_ID };
  return axiosInstance.patch(`/ip_whitelist/${id}`, payload);
};

/**
 * Deletes a whitelisted IP.
 * @param {string} id - The ID of the IP to delete.
 * @returns {Promise} The promise from the axios DELETE request.
 */
export const deleteIpWhitelist = (id) => {
  return axiosInstance.delete(`/ip_whitelist/${id}`, {
    params: { site: process.env.REACT_APP_SITE_ID },
  });
};
